import React from "react";
import Authors from "../../../../atoms/author";
import { formatStoryDate } from "../../../../helper/date-utils";

const DhExclusiveAuthors = ({ story }) => {
  const isBrandspotNoAdStory = story["story-template"] === "brandspot-with-no-ad";
  const isSponsoredStory = story["story-template"] === "sponsored";
  const isBrandspotClientStory = story["story-template"] === "brandspot-client-story";
  const lastUpdatedDateAndTime = formatStoryDate(story && story["last-published-at"]);

  if (isBrandspotNoAdStory || isSponsoredStory || isBrandspotClientStory) return null;
  return (
    <div>
      <Authors
        authors={story.authors}
        clazzName="author-name-image"
        lastUpdatedDateAndTime={lastUpdatedDateAndTime}
        isDHExclusive={true}
      />
    </div>
  );
};

export default DhExclusiveAuthors;
